import { render, staticRenderFns } from "./OPictureUploader.vue?vue&type=template&id=a4ab6c2e&"
import script from "./OPictureUploader.vue?vue&type=script&lang=js&"
export * from "./OPictureUploader.vue?vue&type=script&lang=js&"
import style0 from "./OPictureUploader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports